import ErrorOutlineIcon from "@mui/icons-material/ErrorOutlineOutlined";
import { Alert, AlertTitle, Box, Button, Stack } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

interface ErrorFallbackProps {
  error: Error;
  resetErrorBoundary: () => void;
}

export default function ErrorFallback({
  error,
  resetErrorBoundary,
}: ErrorFallbackProps) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleGoHome = () => {
    resetErrorBoundary();
    navigate("/home");
  };

  return (
    <Box sx={{ p: 3, maxWidth: 720, mx: "auto" }}>
      <Alert
        severity="error"
        icon={<ErrorOutlineIcon fontSize="inherit" />}
        sx={{ mb: 2 }}
      >
        <AlertTitle>{t("error.boundary.title", "Algo deu errado")}</AlertTitle>
        {t(
          "error.boundary.description",
          "Ocorreu um erro ao carregar esta página. Você pode tentar novamente ou voltar para o início.",
        )}
        {error?.message && (
          <Box
            component="pre"
            sx={{
              mt: 2,
              p: 1,
              fontSize: 12,
              backgroundColor: "rgba(0,0,0,0.04)",
              borderRadius: 1,
              overflow: "auto",
              whiteSpace: "pre-wrap",
              wordBreak: "break-word",
            }}
          >
            {error.message}
          </Box>
        )}
      </Alert>
      <Stack direction="row" spacing={2} sx={{ justifyContent: "center" }}>
        <Button variant="contained" onClick={resetErrorBoundary}>
          {t("error.boundary.retry", "Tentar novamente")}
        </Button>
        <Button
          variant="outlined"
          onClick={handleGoHome}
          sx={{
            color: "#000",
            borderColor: "#000",
            "&:hover": {
              borderColor: "#000",
              backgroundColor: "rgba(0,0,0,0.04)",
            },
          }}
        >
          {t("error.boundary.goHome", "Voltar para o início")}
        </Button>
      </Stack>
    </Box>
  );
}
